import {
  Controller
} from "@hotwired/stimulus"
import Swiper from 'swiper';
import {
  Navigation,
  Pagination
} from 'swiper/modules'
//https://swiperjs.com/migration-guide-v10
// 不要用 Swiper.use() 全域註冊：其他 controller 用 modules 參數再傳一次同樣的模組時，
// 模組會被初始化兩次，導覽按鈕會綁到兩個 click listener，一次點擊跳兩張。

export default class extends Controller {
  static targets = ["nav", "container", "row", "link", "input"]

  connect() {
    if (this.hasNavTarget) {
      new Swiper(this.navTarget, {
        modules: [Navigation, Pagination],
        slidesPerView: 3,
        spaceBetween: 10,
        loop: false,
        pagination: false,
        navigation: {
          nextEl: ".swiper-date-next",
          prevEl: ".swiper-date-prev",
        },
        breakpoints: {
          992: {
            slidesPerView: 5,
            spaceBetween: 35,
            loop: false
          }
        }
      });
    } // end nav
  } // connect

  filter(e) {
    let form = document.getElementById("schedule-search-form")

    let formData = new FormData(form)

    fetch(form.action + '?' + new URLSearchParams(formData), {
        method: 'GET',
        headers: {
          'Accept': 'text/vnd.turbo-stream.html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => response.text())
      .then(html => {
        Turbo.renderStreamMessage(html)
      })
  } // end filter

  filter_category(e) {
    e.preventDefault()
    let category = e.currentTarget.dataset.category
    let scheduleFilters = document.querySelectorAll(".schedule-filters .schedule-filter-item.cate")
    scheduleFilters.forEach(filter => {
      filter.classList.remove("active")
      if (filter.dataset.category === category) {
        filter.classList.add("active")
      }
    })
    let schedule_category_id = document.getElementById("schedule_category_id")
    schedule_category_id.value = category
    this.filter()

  }

  filter_access(e) {
    e.preventDefault()
    let access = e.currentTarget.dataset.category
    let accessBtns = document.querySelectorAll(".access-btn")
    accessBtns.forEach(btn => {
      btn.classList.remove("active")
      if (btn.dataset.category === access) {
        btn.classList.add("active")
      }
    })
    let schedule_access = document.getElementById("schedule_access")
    schedule_access.value = access
    this.filter()
  }

  filter_access_select(e) {
    let access = e.currentTarget.value
    let schedule_access = document.getElementById("schedule_access")
    schedule_access.value = access
    this.filter()
  }

  filter_keyword(e) {
    let keyword = e.currentTarget.value
    let schedule_keyword = document.getElementById("schedule_keyword")
    schedule_keyword.value = keyword
    this.filter()
  }

  calculateNewHeight() {
    let totalHeight = 0
    this.rowTargets.forEach(row => {
      if (row.style.display !== "none") {
        totalHeight += row.offsetHeight
      }
    })
    return totalHeight
  } // calculateNewHeight

  toggle(e) {
    e.preventDefault()

    const btn = e.currentTarget
    const contentId = btn.dataset.content
    const contentEl = document.getElementById(contentId)

    if (!contentEl) return

    btn.classList.toggle("active")

    const isHidden = contentEl.classList.contains("d-none") || contentEl.getAttribute("aria-hidden") === "true"

    if (isHidden) {
      // 顯示內容
      // contentEl.classList.remove("d-none")
      contentEl.setAttribute("aria-hidden", "false")

      requestAnimationFrame(() => contentEl.classList.add("is-open"))
    } else {
      // 隱藏內容
      // contentEl.classList.add("d-none")
      contentEl.setAttribute("aria-hidden", "true")

      contentEl.classList.remove("is-open")
    }
  } // toggle

  searchToggle(e) {
    e.preventDefault()

    if (this.hasInputTarget) {
      this.inputTarget.classList.toggle("show")
      if (this.inputTarget.classList.contains("show")) {
        this.inputTarget.focus()
      }
    }
  }

  preventEnter(e) {
    if (e.key === 'Enter') {
      e.preventDefault()
      return false
    }
  }

  filter_date(e) {
    e.preventDefault()
    let date = e.currentTarget.dataset.date
    let schedule_date_input = document.getElementById("schedule_date")
    schedule_date_input.value = date
    let schedule_date_links = document.querySelectorAll(".schedule-date")
    schedule_date_links.forEach(link => {
      link.classList.remove("active")
      if (link.dataset.date === date) {
        link.classList.add("active")
      }
    })
    this.filter()

  }
}